import { put, takeEvery } from 'redux-saga/effects';

import {
  LOAD_MANAGER_EMAIL_BY_ID,
  SET_MANAGER_EMAIL_BY_ID,
} from '../actions/emails';

import { safeApply, safeCall } from './errors';

import { serializeManagerEmail } from '../serializers/emails';
import fetchData from '../../api/fetchData';

const apiManagerMailsUrl = `${process.env.API_HOST_URL}${process.env.API_MANAGER_EMAILS}`;

// eslint-disable-next-line consistent-return
function* fetchManagerEmailByID(id) {
  const { email: unparsedEmail } = yield safeCall(
    fetchData,
    `${apiManagerMailsUrl}/${id}`
  );
  return serializeManagerEmail(unparsedEmail);
}

function* loadManagerEmailById({ payload }) {
  const { id } = payload;
  const email = yield safeCall(fetchManagerEmailByID, id);
  yield put({
    payload: { email },
    type: SET_MANAGER_EMAIL_BY_ID,
  });
}

export default function* () {
  yield takeEvery(LOAD_MANAGER_EMAIL_BY_ID, safeApply(loadManagerEmailById));
}
